import ReportView, { type ReportColumn, type ReportOption } from '../../../components/reports/ReportView';
import { useConfig, listOptions } from '../../../context/ConfigContext';

const COLUMNS: ReportColumn[] = [
  { key: 'invoice_number', label: 'Invoice #' },
  { key: 'customer_name', label: 'Customer' },
  { key: 'invoice_date', label: 'Invoice Date' },
  { key: 'due_date', label: 'Due Date' },
  { key: 'balance', label: 'Balance', align: 'right', type: 'money' },
  { key: 'days_outstanding', label: 'Days Outstanding', align: 'right' },
  { key: 'bucket', label: 'Bucket' },
];

export function ARAgeingReport() {
  const { lists } = useConfig();

  return (
    <ReportView
      title="Accounts Receivable Ageing"
      description="Every customer invoice with an outstanding balance, bucketed by days overdue (current, 1-30, 31-60, 61-90, 91-120, 120+)."
      endpoint="/reports/revenue/ar-ageing"
      columns={COLUMNS}
      filters={['category']}
      categoryOptions={listOptions(lists, 'invoice_type') as ReportOption[]}
      defaultSort="days_outstanding"
      xlsx
    />
  );
}
